class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.querySelector("facet-sidebar") || document.querySelector('facet-sidebar');
      form.onActiveFilterClick(event);
    });
  }
}
customElements.define('facet-remove', FacetRemove);

class FacetSidebarForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      event.preventDefault();
      this.onSubmitHandler(event);
    }, 500);

    if (window.innerWidth < 768) {
      if (this.querySelector('form').getAttribute("id") == 'FacetSortForm') {
        this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
      }
    } else {
      this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    this.querySelector('form').addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetSidebarForm.searchParamsInitial;
      if (searchParams === FacetSidebarForm.searchParamsPrev) return;
      FacetSidebarForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetSidebarForm.searchParamsPrev = searchParams;
    const sections = FacetSidebarForm.getSections();
    document.getElementById('products-container').querySelector('.product-card-grid').classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const facetDataUrl = element => element.url === url;
      FacetSidebarForm.filterData.some(facetDataUrl) ?
        FacetSidebarForm.renderSectionFromCache(facetDataUrl, event) :
        FacetSidebarForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetSidebarForm.updateURLHash(searchParams);
    document.dispatchEvent(new CustomEvent('collection:reloaded'));
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetSidebarForm.filterData = [...FacetSidebarForm.filterData, { html, url }];
        FacetSidebarForm.renderFilters(html, event);
        FacetSidebarForm.renderProductGridContainer(html);
        FacetSidebarForm.renderProductCount(html);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  static renderSectionFromCache(facetDataUrl, event) {
    const html = FacetSidebarForm.filterData.find(facetDataUrl).html;
    FacetSidebarForm.renderFilters(html, event);
    FacetSidebarForm.renderProductGridContainer(html);
    FacetSidebarForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('products-container').innerHTML =
      new DOMParser().parseFromString(html, 'text/html').getElementById('products-container').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('facet-product-count').innerHTML
    const container = document.getElementById('facet-product-count');
    if (container) {
      container.innerHTML = count;
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll('#SidebarfacetForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetSidebarForm.renderActiveFacets(parsedHTML);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facet'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })
  }

  static updateURLHash(searchParams) {
    history.pushState({}, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-card-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData);
  }

  mergeSearchParams(form, searchParams) {
    const params = this.createSearchParams(form);
    params.forEach((value, key) => {
      searchParams.append(key, value);
    });
    return searchParams;
  }

  onSubmitForm(searchParams, event) {
    FacetSidebarForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const currentForm = event.target.closest('form');
    let searchParams = new URLSearchParams();
    const sortFilterForms = document.querySelectorAll('facet-sidebar form');

    sortFilterForms.forEach((form) => {
      if (form.id === 'SidebarfacetForm' || form.id === 'FacetSortForm') {
        searchParams = this.mergeSearchParams(form, searchParams);
      }
    });

    this.onSubmitForm(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetSidebarForm.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }
}

FacetSidebarForm.filterData = [];
FacetSidebarForm.searchParamsInitial = window.location.search.slice(1);
FacetSidebarForm.searchParamsPrev = window.location.search.slice(1);

customElements.define('facet-sidebar', FacetSidebarForm);
FacetSidebarForm.setListeners();

class PriceSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let rangeslider = this.querySelector('.range-slider'),
      amounts = this.querySelector('.facets-price-ranges'),
      args = {
        start: [parseFloat(rangeslider.dataset.minValue), parseFloat(rangeslider.dataset.maxValue)],
        connect: true,
        step: 1,
        range: {
          'min': parseFloat(rangeslider.dataset.min),
          'max': parseFloat(rangeslider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-sidebar') || document.querySelector('facet-sidebar');

    if (rangeslider.classList.contains('noUi-target')) {
      rangeslider.noUiSlider.destroy();
    }

    noUiSlider.create(rangeslider, args);

    rangeslider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });

    rangeslider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-range', PriceSlider);

class ShowMoreFilterButton extends HTMLElement {
  constructor() {
    super();
    const attributes = {
      expanded: "aria-expanded"
    };
    this.querySelector(".show-more-button").addEventListener("click", (event) => {
      const filter = this.closest(".facets-accordion");
      filter.setAttribute(attributes.expanded, (filter.getAttribute(attributes.expanded) === "false").toString()),
        filter.querySelector(".more-items").classList.toggle("hidden")
      this.querySelectorAll(".visible-hidden").forEach(element => element.classList.toggle("hidden"))
    })
  }
}
customElements.define("show-more-button", ShowMoreFilterButton);

class FacetsDrawer extends HTMLElement {
  constructor() {
    super();
    this.querySelector("[data-drawer-head]")?.addEventListener("click", this.openDrawer.bind(this));
    document.addEventListener("keydown", this.handleKeyDown.bind(this));
  }

  getDrawerEl() {
    return document.querySelector("#facets-filte-drawer") || document.querySelector("facets-filte-drawer");
  }

  openDrawer(event) {
    event.preventDefault();
    const drawer = this.getDrawerEl();
    if (!drawer) return;

    // CRITICAL: Prevent body scroll
    document.body.classList.add('drawer-open');

    drawer.classList.add("open");
    this.bindCloseButtons(drawer);

    // Optional focus trap hooks if your theme provides them
    if (typeof trapFocusElements === "function") {
      trapFocusElements(drawer);
    }
  }

  bindCloseButtons(drawer) {
    const closeElements = drawer.querySelectorAll("[data-close-drawer]");
    closeElements.forEach((el) => {
      if (el.dataset.boundClose === "1") return;
      el.dataset.boundClose = "1";
      el.addEventListener("click", (event) => {
        event.preventDefault();
        this.forceClose(drawer);
      });
    });
  }

  forceClose(drawer) {
    drawer.classList.remove("open");

    // CRITICAL: Restore body scroll
    document.body.classList.remove('drawer-open');

    if (typeof removeTrapFocus === "function") {
      removeTrapFocus();
    }
  }

  handleKeyDown(event) {
    if (event.key === "Escape") {
      const drawer = this.getDrawerEl();
      if (!drawer) return;
      this.forceClose(drawer);
    }
  }
}
customElements.define("facets-drawer", FacetsDrawer);

class SwipeDrawer {
  constructor(drawerElement) {
    this.drawer = drawerElement;
    this.startY = null;
    this.currentY = null;
    this.isDragging = false;
    this.threshold = 100;
    this.drawerCard = this.drawer.querySelector('.drawer-inner-card');
    this.overlay = this.drawer.querySelector('.overlay');
    this.header = this.drawer.querySelector('.drawer-head');
    this.swipeHandle = this.drawer.querySelector('.drawer-swipe-handle');

    // Bind once
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);

    // ✅ ADDED: allow hard swipe-down on the actual card too (classic drawer behavior)
    // (This still respects inner scroll so you can scroll filters normally.)
    [this.overlay, this.header, this.swipeHandle, this.drawerCard].forEach(el => {
      if (el) {
        el.addEventListener('touchstart', this.onTouchStart, { passive: true });
        el.addEventListener('touchmove', this.onTouchMove, { passive: false });
        el.addEventListener('touchend', this.onTouchEnd, { passive: true });
      }
    });
  }

  onTouchStart(event) {
    // Only operate when drawer is open (prevents random swipes on page)
    if (!this.drawer.classList.contains('open')) return;

    this.isDragging = false;
    this.startY = event.touches[0].clientY;
    this.currentY = this.startY;
    this.drawer.classList.remove('dragging');
  }

  // ✅ ADDED: only allow swipe-close when content is at the top (so normal scrolling works)
  isDraggingAllowed(event) {
    // If the swipe starts inside a scrollable area, only allow "pull down to close"
    // when that scroll area is at scrollTop 0.
    const scrollable =
      event.target.closest('.drawer-content-contain') ||
      event.target.closest('.drawer-body');

    if (!scrollable) return true;

    const atTop = scrollable.scrollTop <= 0;
    const movingDown = this.currentY > this.startY;
    return atTop && movingDown;
  }

  onTouchMove(event) {
    if (!this.drawer.classList.contains('open')) return;
    if (this.startY === null) return;

    this.currentY = event.touches[0].clientY;

    // Respect scroll: don't hijack normal scrolling
    if (!this.isDraggingAllowed(event)) return;

    const translateY = Math.max(0, this.currentY - this.startY);

    // Only start dragging if user actually pulls down a bit
    if (translateY < 6) return;

    this.isDragging = true;

    if (this.drawerCard) {
      this.drawerCard.style.transform = `translateY(${translateY}px)`;
      this.drawer.classList.add('dragging');
      event.preventDefault(); // prevent bounce while dragging card
    }
  }

  onTouchEnd() {
    if (!this.drawer.classList.contains('open')) {
      this.resetState();
      return;
    }

    if (!this.isDragging || this.startY === null) {
      this.resetState();
      return;
    }

    const swipeDistance = this.currentY - this.startY;

    if (swipeDistance > this.threshold) {
      this.closeDrawer();
    } else {
      this.resetDrawerPosition();
    }

    this.drawer.classList.remove('dragging');
    this.resetState();
  }

  resetState() {
    this.isDragging = false;
    this.startY = null;
    this.currentY = null;
  }

  closeDrawer() {
    if (!this.drawerCard) return;

    this.drawerCard.style.transform = `translateY(100%)`;

    setTimeout(() => {
      this.drawer.classList.remove("open");

      // CRITICAL: Restore body scroll
      document.body.classList.remove('drawer-open');
    }, 260);

    setTimeout(() => this.drawerCard.style.removeProperty("transform"), 420);
  }

  resetDrawerPosition() {
    if (this.drawerCard) this.drawerCard.style.removeProperty("transform");
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const drawerElement = document.querySelector('facets-filte-drawer');
  if (drawerElement) new SwipeDrawer(drawerElement);
});
